export const BRAND_ILLUSTRATION_2026_NAMES = {
    'admin-malty-red.svg': 'admin-computer--high.svg',
    'admin-malty.svg': 'admin-computer--high.svg',
    'business.referral-red.svg': 'gift-popping--high.svg',
    'bust-digital-worker-man-red.svg': 'busy-digitalworker-man--high.svg',
    'bust-digital-worker-man.svg': 'busy-digitalworker-man--high.svg',
    'bust-digital-worker-woman-red.svg': 'busy-digitalworker-woman--high.svg',
    'bust-digital-worker-woman.svg': 'busy-digitalworker-woman--high.svg',
    'choice-red.svg': 'profile-cards--high.svg',
    'choice.svg': 'profile-cards--high.svg',
    'contract-red.svg': 'paper-signature--high.svg',
    'contract.svg': 'paper-signature--high.svg',
    'cost-red.svg': 'woman-picking-cake-slice--high.svg',
    'cost.svg': 'woman-picking-cake-slice--high.svg',
    'entire-digital-worker-man-red.svg': 'busy-digitalworker-man--high.svg',
    'entire-digital-worker-man.svg': 'busy-digitalworker-man--high.svg',
    'freelancer-marketplace-red.svg': 'hand-clicking-malt.svg',
    'freelancer-marketplace.svg': 'hand-clicking-malt.svg',
    'freelancer-red.svg': 'freelancer-tag--high.svg',
    'freelancer.svg': 'freelancer-tag--high.svg',
    'joyfull-team.svg': 'clapping-hands--high.svg',
    'joyful-team-red.svg': 'clapping-hands--high.svg',
    'malt-brand-choice.svg': 'arm-rising-key--high.svg',
    'malt-brand-search.svg': 'binoculars--high.svg',
    'malt-brand-wefindtalentforyou.svg': 'mailbox-mail-out--high.svg',
    'malt-strategy-curatedprofiles-large.svg': 'profile-zoom--high.svg',
    'malt-strategy-hasslefreepayment-large.svg': 'credit-card-and-invoice--high.svg',
    'malt-strategy-highqualityproducts-large.svg': 'woman-holding-stars--high.svg',
    'malt-strategy-personalizedsupport-large-svg': 'clapping-hands--high.svg',
    'malt-strategy-strongcommunity-large.svg': 'group-discussion--high.svg',
    'malt-strategy-transparentpricing-large.svg': 'jar-with-money--high.svg',
    'malt-strategy-vettedprofiles-large.svg': 'winner-badge--high.svg',
    'malty-red.svg': 'clapping-hands--high.svg',
    'malty.svg': 'clapping-hands--high.svg',
    'mediation-red.svg': 'duo-high-five--high.svg',
    'mediation.svg': 'duo-high-five--high.svg',
    'outside-of-box-red.svg': 'invite-freelancer--high.svg',
    'outside-of-box.svg': 'invite-freelancer--high.svg',
    'performance-red.svg': 'race-car--high.svg',
    'performance.svg': 'race-car--high.svg',
    'playing-cards-red.svg': 'profile-cards--high.svg',
    'playing-cards.svg': 'profile-cards--high.svg',
    'questions-red.svg': 'man-rising-hand--high.svg',
    'questions.svg': 'man-rising-hand--high.svg',
    'read-contract-red.svg': 'contract-on-malt--high.svg',
    'read-contract.svg': 'contract-on-malt--high.svg',
    'reporting-red.svg': 'dataviz-dashboard-bars--high.svg',
    'reporting.svg': 'dataviz-dashboard-bars--high.svg',
    'safe-red.svg': 'safe-box--high.svg',
    'safe.svg': 'safe-box--high.svg',
    'search-red.svg': 'binoculars--high.svg',
    'search.svg': 'binoculars--high.svg',
    'security-red.svg': 'arm-key-lock--high.svg',
    'security.svg': 'arm-key-lock--high.svg',
    'share.svg': 'group-discussion--high.svg',
    'share-red.svg': 'group-discussion--high.svg',
    'star-red.svg': 'rising-trophy--high.svg',
    'star.svg': 'rising-trophy--high.svg',
    'success-red.svg': 'rocket-launch--high.svg',
    'success.svg': 'rocket-launch--high.svg',
    'super-malter-red.svg': 'trophy--high.svg',
    'super-malter.svg': 'trophy--high.svg',
    'team-project-red.svg': 'assemble-puzzle--high.svg',
    'team-project.svg': 'assemble-puzzle--high.svg',
    'thinking-malty.svg': 'plug-unplugged--high.svg',
    'thinking-malty-red.svg': 'plug-unplugged--high.svg',
    'thumb-up-red.svg': 'arm-thumbup--high.svg',
    'thumb-up.svg': 'arm-thumbup--high.svg',
    'united-team-4-people-red.svg': 'teamwork-dropzone--high.svg',
    'united-team-4-people.svg': 'teamwork-dropzone--high.svg',
    'values-red.svg': 'growing-plant--high.svg',
    'values.svg': 'growing-plant--high.svg',
    'send-message-red.svg': 'computer-mail-notification--high.svg',
    'send-message.svg': 'computer-mail-notification--high.svg',
};
